
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { IDeleteDataResponseAndPayload, TResponse, TResponseWithQData } from "../../../types/common";
import { ITeamPayloadAndResponse } from '../../../types/api/team';


export async function saveTeam(data: ITeamPayloadAndResponse): Promise<AxiosResponse<TResponse<ITeamPayloadAndResponse>>> {
    return axios.post<TResponse<ITeamPayloadAndResponse>>(API_ENDPOINTS.TEAM_SAVE, data)
}

export async function listTeam(qData: QData): Promise<AxiosResponse<TResponseWithQData<ITeamPayloadAndResponse[]>>> {
    return axios.get(API_ENDPOINTS.TEAM_LIST, {
        params: qData
    })
}

export async function deleteTeam(data: IDeleteDataResponseAndPayload): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
    return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.TEAM_DELETE, data)
}

export async function teamDetails(id:string): Promise<AxiosResponse<TResponse<ITeamPayloadAndResponse>>> {
    return axios.get(`${API_ENDPOINTS.TEAM_DETAILS}/${id}`)
}

